import { readStates, saveStates, states } from '@/constants/lifecycle';

const tasksActions = {
  CLOSE_REQUEST_TASKS: 'CLOSE_REQUEST_TASKS',
  CLAIM_REQUEST_TASK: 'CLAIM_REQUEST_TASK',
  COMPLETE_REQUEST_TASK: 'COMPLETE_REQUEST_TASK',
  COMPLETE_REQUEST_TASKS_SUCCESS: 'COMPLETE_REQUEST_TASKS_SUCCESS',
  EDIT_REQUEST_TASK: 'EDIT_REQUEST_TASK',
  FETCH_ACTIVE_REQUEST_TASK: 'FETCH_ACTIVE_REQUEST_TASK',
  FETCH_REQUEST_TASK_VIEWS: 'FETCH_REQUEST_TASK_VIEWS',
  FETCH_REQUEST_TASKS: 'FETCH_REQUEST_TASKS',
  HIDE_MANAGE_TASK: 'HIDE_MANAGE_TASK',
  HIDE_REQUEST_TASK: 'HIDE_REQUEST_TASK',
  MANAGE_REQUEST_TASK: 'MANAGE_REQUEST_TASK',
  REFRESH_REQUEST_TASKS: 'REFRESH_REQUEST_TASKS',
  SAVE_REQUEST_TASK: 'SAVE_REQUEST_TASK',
  SHOW_ACTIVE_REQUEST_TASK: 'SHOW_ACTIVE_REQUEST_TASK',
  SHOW_ACTIVE_REQUEST_TASK_ERROR: 'SHOW_ACTIVE_REQUEST_TASK_ERROR',
  SHOW_MANAGE_REQUEST_TASK: 'SHOW_MANAGE_REQUEST_TASK',
  SHOW_MANAGE_REQUEST_TASK_ERROR: 'SHOW_MANAGE_REQUEST_TASK_ERROR',
  SHOW_MANAGE_REQUEST_TASK_SUCCESS: 'SHOW_MANAGE_REQUEST_TASK_SUCCESS',
  SHOW_REQUEST_TASK: 'SHOW_REQUEST_TASK',
  SHOW_REQUEST_TASK_VIEWS: 'SHOW_REQUEST_TASK_VIEWS',
  SHOW_REQUEST_TASK_VIEWS_ERROR: 'SHOW_REQUEST_TASK_VIEWS_ERROR',
  SHOW_REQUEST_TASKS: 'SHOW_REQUEST_TASKS',
  SHOW_REQUEST_TASKS_ERROR: 'SHOW_REQUEST_TASKS_ERROR',
  SHOW_UPDATE_REQUEST_TASK_ERROR: 'SHOW_UPDATE_REQUEST_TASK_ERROR',
  SHOW_UPDATE_REQUEST_TASK_SUCCESS: 'SHOW_UPDATE_REQUEST_TASK_SUCCESS',
  TOGGLE_REQUEST_TASK_COLUMN_ORDER_BY: 'TOGGLE_REQUEST_TASK_COLUMN_ORDER_BY',
  UPDATE_ACTIVE_TASK_PROPERTIES: 'UPDATE_ACTIVE_TASK_PROPERTIES',
  UPDATE_MANAGE_TASK_PROPERTIES: 'UPDATE_MANAGE_TASK_PROPERTIES',
  UPDATE_REQUEST_TASK_FORM_PROPERTIES: 'UPDATE_REQUEST_TASK_FORM_PROPERTIES',
  UPDATE_REQUEST_TASK_TAB: 'UPDATE_REQUEST_TASK_TAB',
  TOGGLE_REQUEST_TASKS_PRESENTATION: 'TOGGLE_REQUEST_TASKS_PRESENTATION',
  UPDATE_REQUEST_TASKS_FILTER: 'UPDATE_REQUEST_TASKS_FILTER',
  UPDATE_REQUEST_TASKS_VIEW_FILTER: 'UPDATE_REQUEST_TASKS_VIEW_FILTER',
};

export const requestTaskStates = {
  ...readStates,
  ...saveStates,
  claimStatus: states.NONE,
  completeStatus: states.NONE,
};

export const requestTaskPermissions = {
  CLAIM: 'can_claim',
  UNCLAIM: 'can_unclaim',
  UPDATE: 'can_update',
};

export const requestTaskTabs = {
  TASK: { name: 'task', icon: 'calendar check', isSection: true },
  SUMMARY: { name: 'summary', icon: 'list' },
  DESTINATION: { name: 'destination', icon: 'cube' },
  PROJECT: { name: 'project', icon: 'briefcase', isSection: true },
  ABOUT: { name: 'about', icon: 'info circle', isSection: true },
  COMMENTS: { name: 'comments', icon: 'comments outline', isSection: true },
};

export const requestTaskLists = ['all'];

export default tasksActions;
